<script setup>
  import {ref, computed, onMounted, onBeforeUnmount, getCurrentInstance, watch, defineExpose} from 'vue'
  import {onBeforeRouteLeave, useRoute, useRouter} from 'vue-router'
  import { usePageLoadingStore } from "../../../../../stores/pageLoading";
  import { useUserStore } from "../../../stores/user";
  import { useSiteMenuStore } from "../../../../../stores/sitemenu";
  import { useNavigationStore } from '../../../../../stores/navigation';
  import { storeToRefs } from 'pinia';
  import SNB from '../../../../../layouts/nav/SNB.vue'
  import KSAInputNumber from "../../../../../components/ui-components/input/KSAInputNumber.vue";
  import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
  import fileService from "@/services/fileService";
  import mypageJobFairJobNoticeService from '../../../services/mypage/jobFair/mypageJobFairJobNoticeService';
  import mypageJobFairService from '../../../services/mypage/jobFair/mypageJobFairService';
  import _ from 'lodash'

  const route = useRoute();
  const router = useRouter();

  const navigationStore = useNavigationStore();
  const { previousRoute } = storeToRefs(navigationStore);

  const globals = getCurrentInstance().appContext.config.globalProperties;
  const { $toast, $gb, $fileSize, alert, confirm } = globals;
  const loadingStore = usePageLoadingStore()
  const userStore = useUserStore()

  const resumeId = ref(route.query.resumeId || ''); // 면접제안 등록을 위한 데이터 (resumeId가 있으면 등록완료 시 면접제안 팝업 띄움)
  const returnRouteName = ref(route.query.returnRouteName || '');
  const returnRouteQuery = ref(route.query.returnRouteQuery || '');

  const modalContent = ref([]);
  const okButtonText = ref("네");
  const cancelButtonText = ref("아니오");

  let clickLogout = false; // 로그아웃 클릭 여부
  const siteMenuStore = useSiteMenuStore();

  let isSaved = false; // 저장 여부
  const createCorpFileNameSize = ref(null); // 파일명 + 용량

  // 로그아웃버튼 클릭 이벤트 핸들러
  const handleClickLogout = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation(); // 같은 요소의 다른 이벤트 리스너 실행 방지

    clickLogout = true;

    modalContent.value = ["페이지를 나가겠습니까?", "페이지 이동 시 입력한 정보는 저장되지 않습니다"];
    const ok = await confirm(modalContent.value, okButtonText.value, cancelButtonText.value);
    if(ok) {
      userStore.setUser({});
      siteMenuStore.getSiteMenu()
      router.push({name: 'Home', query: { logout: 'true' }});
    } else {
      clickLogout = false;
    }

    // 추가적으로 Header의 logout 함수 실행을 완전히 방지
    return false;
  };

  const saveIsDisabled = ref(false)

  const NOTE_HTML = '<strong>[전형단계]</strong><br>' +
      '<span style="color:hsl(0, 0%, 70%);">예시)</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">①지원서 접수</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">②서류전형</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">③1차면접</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">④2차면접</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">⑤채용검진</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">⑥최종합격</span><br>' +
      '<br>' +
      '<strong>[기타]</strong><br>' +
      '<span style="color:hsl(0, 0%, 70%);">예시)</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">-최종 합격 후, 회사가 지정하는 입사일에 입사 불가할 경우 합격이 취소되거나 전형상의 불이익이 있을 수 있습니다.</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">-지원서를 포함하여 채용 전형 진행 중 모든 과정에서 제출한 내용이 사실과 다르거나 문서로 증빙이 불가할 경우 합격이 취소되거나 전형상의 불이익이 있을 수 있습니다.</span><br>';


  const jobNoticeCreate = ref({
    jobName: '', // 채용공고명
    interests: '', // 관심카테고리
    job: '', // 직무
    recruitArea: '', // 모집분야명
    recruitCnt: 0, // 모집인원
    jobExperience: '', //  경력
    schoolGb: '', // 학력 05 고졸 01 대학(2,3년) 02 대학(4년) 03 대학원(석사) 04 대학원(박사)
    specialTreat: '', // 우대사항(자격증)
    workArea1: '', // 근무지역_시도
    workArea2: '', // 근무지역_시군구
    workHomeYn: 'N', // 재택가능여부
    workType: '', // 근무형태
    salaryGb: '01', // 급여구분
    salary: 0, // 급여
    note: NOTE_HTML, // 기타 요건
    recruitStartYmd: "", // 채용기간(시작일)
    recruitEndYmd: "", // 채용기간(종료일)
    intvGb: '01', // 면접 방식
    fileYn: "N", // 회사이력서파일유무
    corpResumeAttaches: [
      {
        "attachSeq": 0,
        "fileName": "",
        "fileSize": "",
        "fileDir": "",
        "fileOrder": 0,
        "deleteYn": ""
      }
    ], // 회사이력서파일
  })

  const inputError = ref({
    jobName: '', // 채용공고명
    interests: '', // 관심카테고리
    job: '', // 직무
    recruitArea: '',// 모집분야명
    recruitCnt: '', // 모집인원
    jobExperience: '', //  경력
    schoolGb: '', // 학력
    specialTreat: '', // 우대사항(자격증)
    workArea: '', // 근무지역
    workType: '', // 근무형태
    salary: '', // 급여구분
  })

  const data_interests = ref(globals.$interests) // 관심 카테고리
  const data_job = ref(globals.$desiredJob) // 직무
  const data_jobExperience = ref(globals.$jobExperience) // 경력
  const data_workType = ref(globals.$workType) // 근무형태

  // 관심 카테고리
  const interestCount = computed(()=>{
    return _.filter(data_interests.value, {'on': true}).length || 0;
  })

  const onClickInterest = (interest) => {
    inputError.value.interests = '';
    if(interest.on) {
      interest.on  = false;
    } else {
      if(interestCount.value < 3) {
        interest.on = true;
      } else {
        inputError.value.interests = '최대 3개까지 선택할 수 있습니다.';
      }
    }
  }

  // 직무
  const onClickJob = (job) => {
    inputError.value.job = '';
    if(job.on) {
      job.on  = false;
    } else {
      job.on = true;
    }
  }

  // 경력
  const onClickJobExperience = (jobExperience) => {
    inputError.value.jobExperience = '';
    if(jobExperience.on) {
      jobExperience.on  = false;
    } else {
      jobExperience.on = true;
    }
  }

  // 근무지역
  const onSelectedWorkArea1 = (option) => {
    jobNoticeCreate.value.workArea1 = option;
    inputError.value.workArea = '';
  }

  const onSelectedWorkArea2 = (option) => {
    jobNoticeCreate.value.workArea2 = option;
    inputError.value.workArea = '';
  }

  const onClickWorkHomeYn = (select) => {
    inputError.value.workArea = '';
    if(select === 'Y') {
      jobNoticeCreate.value.workHomeYn = 'N';
    } else {
      jobNoticeCreate.value.workHomeYn = 'Y';
    }
  }

  // 근무형태
  const onClickWorkType = (selectedWorkType) => {
    inputError.value.workType = '';
    data_workType.value.forEach(item => {
      item.on = (item === selectedWorkType);
    });
  }

  // 공고 등록
  const saveJobNotice = () => {
    // 이미 저장 처리 중이면 재호출 방지
    if (saveIsDisabled.value) {
      return;
    }
    // 저장 처리 동안 버튼 비활성화
    saveIsDisabled.value = true;

    let isInvalid = false;

    // 공고 제목 저장
    const { jobName } = jobNoticeCreate.value;
    inputError.value.jobName = '';

    const jobNameTrim = jobName ? jobName.trim() : '';
    if(!jobNameTrim) {
      inputError.value.jobName = '공고 제목을 입력하세요.';
      isInvalid = true;
    } else if (jobNameTrim.length > 50) {
      inputError.value.jobName = '공고 제목은 최대 50자입니다.';
      isInvalid = true;
    }

    // 모집 분야
    const interests = _.map(_.filter(data_interests.value, {'on': true}), 'value').join(',');
    const job = _.map(_.filter(data_job.value, {'on': true}), 'value').join(',');
    const { recruitArea, recruitCnt } = jobNoticeCreate.value;

    inputError.value.interests = '';
    inputError.value.job = '';
    inputError.value.recruitArea = '';
    inputError.value.recruitCnt = '';

    if(!interests) {
      inputError.value.interests = '관심 카테고리를 선택하세요.';
      isInvalid = true;
    } else if (interests.length > 200) {
      $toast('error', '관심 카테고리가 너무 깁니다.');
      isInvalid = true;
    }

    if(!job) {
      inputError.value.job = '직무를 선택하세요.';
      isInvalid = true;
    } else if (job.length > 200) {
      $toast('error', '직무 선택 값이 너무 깁니다.');
      isInvalid = true;
    }

    const recruitAreaTrim = recruitArea ? recruitArea.trim() : '';
    if (!recruitAreaTrim) {
      inputError.value.recruitArea = '모집분야명을 입력하세요.';
      isInvalid = true;
    } else if (recruitAreaTrim.length > 50) {
      inputError.value.recruitArea = '모집분야명은 최대 50자입니다.';
      isInvalid = true;
    }

    const recruitCntNum = Number(recruitCnt);
    if (!Number.isInteger(recruitCntNum) || recruitCntNum <= 0) {
      inputError.value.recruitCnt = '모집인원은 1명 이상이어야 합니다.';
      isInvalid = true;
    }

    // 지원 자격 / 근무조건
    const jobExperience = _.map(_.filter(data_jobExperience.value, {'on': true}), 'value').join(',');
    const workType = _.map(_.filter(data_workType.value, {'on': true}), 'value').join(',');

    const {
      schoolGb, specialTreat, workArea1, workArea2, workHomeYn, salaryGb, note, 
      recruitStartYmd, recruitEndYmd, intvGb, fileYn, corpResumeAttaches,
    } = jobNoticeCreate.value;

    if (!jobExperience) {
      inputError.value.jobExperience = '경력을 선택하세요.';
      isInvalid = true;
    } else if (jobExperience.length > 10) {
      inputError.value.jobExperience = '경력 값은 최대 10자입니다.';
      isInvalid = true;
    }

    if (!schoolGb) {
      inputError.value.schoolGb = '학력을 선택하세요.';
      isInvalid = true;
    } else if (schoolGb.length > 2) {
      inputError.value.schoolGb = '학력 값은 최대 2자입니다.';
      isInvalid = true;
    }

    const specialTreatTrim = specialTreat ? specialTreat.trim() : '';
    if (!specialTreatTrim) {
      inputError.value.specialTreat = '우대 사항을 입력하세요.';
      isInvalid = true;
    } else if (specialTreatTrim.length > 50) {
      inputError.value.specialTreat = '우대 사항은 최대 50자입니다.';
      isInvalid = true;
    }

    const workArea1Trim = workArea1 ? workArea1.trim() : '';
    const workArea2Trim = workArea2 ? workArea2.trim() : '';
    // "시/도 선택" 문구는 빈값으로 처리
    const workArea1Clean = workArea1Trim === '시/도 선택' ? '' : workArea1Trim;
    const workArea2Clean = workArea2Trim === '시/구/군 선택' ? '' : workArea2Trim;
    const area1filter = !workArea1Clean;
    const area2filter = !workArea2Clean;

    if (!workHomeYn || workHomeYn === 'N' && (area1filter || area2filter)) {
      inputError.value.workArea = '근무지역을 선택하세요.';
      isInvalid = true;
    } else {
      inputError.value.workArea = '';
    }

    if (!workType) {
      inputError.value.workType = '근무형태를 선택하세요.';
      isInvalid = true;
    } else if (workType.length > 10) {
      inputError.value.workType = '근무형태 값은 최대 10자입니다.';
      isInvalid = true;
    }

    let salary = jobNoticeCreate.value.salary;

    if (salaryGb === '01') {
      if (!salary) {
        salary = 0;
      }
    } else if (salaryGb !== '01') {
      const salaryNum = Number(salary);
      if (!Number.isInteger(salaryNum) || salaryNum <= 0) {
        inputError.value.salary = '급여를 입력하세요.';
        isInvalid = true;
      } else if (String(salaryNum).length > 6) {
        inputError.value.salary = '급여는 최대 6자리까지 입력 가능합니다.';
        isInvalid = true;
      }
      salary = salaryNum;
    }

    if (!salaryGb || salaryGb.length > 2) {
      inputError.value.salary = '급여구분을 선택하세요.';
      isInvalid = true;
    }

    // if (note && String(note).length > 4000) {
    //   $toast('error', '기타요건은 최대 4000자까지 입력 가능합니다.');
    //   isInvalid = true;
    // }

    if(fileYn === 'Y' && !corpResumeAttaches[0].fileName) {
      inputError.value.corpResumeAttaches = '회사 이력서 양식을 첨부하세요.';
      isInvalid = true;
    }

    // 저장 처리
    try {
      if (!isInvalid) {
        const params = {
          jobName: jobNameTrim,
          interests,
          job,
          recruitArea: recruitAreaTrim,
          recruitCnt: recruitCntNum,
          jobExperience,
          schoolGb,
          specialTreat: specialTreatTrim,
          workArea1: workArea1Clean,
          workArea2: workArea2Clean,
          workHomeYn,
          workType,
          salaryGb,
          salary,
          note,
          recruitStartYmd, // "20260315",
          recruitEndYmd, // "20260320",
          intvGb, // "01",
          fileYn, // "N",
          corpResumeAttaches: fileYn === 'Y' ? corpResumeAttaches : [],
          createId: 0
        };

        loadingStore.loading = true;
        mypageJobFairJobNoticeService.createJobNotice(params)
          .then(async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === 'success') {
              isSaved = true;
              const jobNoticeSeq = res.data.result;
              _afterCreate(jobNoticeSeq);
            } else {
              alert([res.response.data.result.message]);
              saveIsDisabled.value = false;
            }
          })
          .catch((res) => {
            alert([res.response.data.result.message]);
            loadingStore.loading = false;
            saveIsDisabled.value = false;
          });
      } else {
        // $toast("error", "올바르게 입력되지 않은 항목이 있습니다.");
        alert("필수 입력사항을 확인해 주세요.");
        saveIsDisabled.value = false;
      }
    } catch (error) {
      saveIsDisabled.value = false;
      console.log(error);
    }
  }

  const _afterCreate = async (jobNoticeSeq) => {
    if(!resumeId.value) {
      await alert(["채용공고 등록이 완료되었습니다."]);
      goBack();
    } else { // 면접제안 등록
      const ok = await confirm(["채용공고 등록이 완료되었습니다.", "해당 채용공고로 면접제안을 하시겠습니까?"], "면접제안");
      if(ok) {
        const paramObj = {
          resumeId: resumeId.value,
          jobNoticeSeq,
        };

        loadingStore.loading = true;
        mypageJobFairService.createInterviewProposalEntry(paramObj)
          .then(async (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
              await alert(["면접제안을 하였습니다."]);
              goBack();
            } else {
              alert(["면접제안을 실패하였습니다."]);
            }
          })
          .catch( (error) =>  {
            alert(["면접제안을 실패하였습니다."]);
            loadingStore.loading = false;
          }); 
      } else {
        await alert(["채용공고 등록이 완료되었습니다."]);
        goBack();
      }
    }
  }


  const clickCancel = () => {
    alert("채용공고 등록이 취소되었습니다.");
    isSaved = true;
    goBack();
  }

  // 이력서 양식 초기화
  const resetFile = (val) => {
    inputError.value.fileYn = ''
    if (val === 'N') {
      jobNoticeCreate.value.corpResumeAttaches[0].fileName = ''
      jobNoticeCreate.value.corpResumeAttaches[0].fileDir = ''
      jobNoticeCreate.value.corpResumeAttaches[0].fileSize = ''
      createCorpFileNameSize.value = ''
    }
  }

  // 회사 이력서 양식 업로드
  const uploadFileCorpResume = () => {
    const input = document.createElement('input');
    input.type= 'file';
    input.click();

    input.addEventListener('change', function(event){
      const file = event.target.files[0];

      if(file.size > 1024 * 1024 * 200) {
        alert(["최대 200MB까지 첨부 가능합니다."]);
        return;
      }

      let paramObj = {
        container: 'private',
        folder: 'corpResumeAttaches',
        file,
      }
      fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            jobNoticeCreate.value.corpResumeAttaches[0].fileName = result.originalFilename;
            jobNoticeCreate.value.corpResumeAttaches[0].fileSize = result.fileSize;
            jobNoticeCreate.value.corpResumeAttaches[0].fileDir = result.blobUrl;
            const upFileSize = $fileSize(result.fileSize);
            createCorpFileNameSize.value = result.originalFilename + '  ' + upFileSize;
          }
        })
        .catch( (error) =>  {
          console.log(error);
        });
    });
  }

  // 회사 이력서 양식 삭제
  const removeFileCorpResume = () => {
    jobNoticeCreate.value.corpResumeAttaches[0].fileName = '';
    jobNoticeCreate.value.corpResumeAttaches[0].fileSize = '';
    jobNoticeCreate.value.corpResumeAttaches[0].fileDir = '';
    createCorpFileNameSize.value = '';
    inputError.value.corpResumeAttaches = '';
  }


  // 특수문자 작성 안됨
  const filterText = (value) => {
    return value.replace(/[^a-zA-Z0-9ㄱ-ㅎ가-힣\s]/g, ''); // 특수문자 제거
  }

  const onInputChange = (event, key) => {
    jobNoticeCreate.value[key] = filterText(event.target.value); // 필터링된 값 적용
    if (key === 'jobName') {
      inputError.value.jobName = '' ? '공고 제목을 입력하세요.' : '';
    } else if (key === 'recruitArea') {
      inputError.value.recruitArea = '' ? '모집분야명을 입력하세요.' : '';
    } else if (key === 'specialTreat') {
      inputError.value.specialTreat = '' ? '우대 사항을 입력하세요.' : '';
    }
  }

  const validateText = (key) => {
    if (key === 'recruitCnt') {
      inputError.value.recruitCnt = '' ? '모집인원을 입력하세요.' : '';
    } else {
      inputError.value.salary = '' ? '급여를 선택하세요.' : '';
    }
  }

  const goBack = () => {
    if (returnRouteName.value) {
      let parsedQuery = {};
      try {
        parsedQuery = returnRouteQuery.value ? JSON.parse(returnRouteQuery.value) : {};
      } catch (e) {
        parsedQuery = {};
      }
      router.push({ name: returnRouteName.value, query: parsedQuery });
      return;
    }

    if (resumeId.value) {
      router.push({ name: 'MatchingJob', query : { tab: 'talent' }});
    } else if(previousRoute.value) {
      router.push(previousRoute.value);
    } else {
      router.push({ name: 'MyPageCorpJobFair', query : { tab: 'job-postings' }});
    }
  }

  // 페이지 이탈
  onBeforeRouteLeave(async (to, from, next) => {
    if(to.path === "mypage/corpJobFair" || isSaved) {
      next();
    } else {
      if(!clickLogout) {
        modalContent.value = ["페이지를 나가겠습니까?", "페이지 이동 시 입력한 정보는 저장되지 않습니다"];
        const ok = await confirm(modalContent.value, okButtonText.value, cancelButtonText.value);
        if(ok) {
          next();
        } else {
          // 사용자가 취소를 선택한 경우 navigation을 중단
          next(false);
        }
      } else {
        // clickLogout이 true인 경우 navigation 허용
        next();
      }
    }
  })

  // 컴포넌트 언마운트 시 이벤트 리스너 정리
  onBeforeUnmount(() => {
    let logoutBtn = document.querySelector('.btn-logout');
    if(logoutBtn) {
      logoutBtn.removeEventListener('click', handleClickLogout, true);
    }
  });

  onMounted(()=> {
    _.each(data_interests.value, el => {el.on = false;})
    _.each(data_job.value, el => {el.on = false;})
    _.each(data_jobExperience.value, el => {el.on = false;})
    _.each(data_workType.value, el => {el.on = false;})

    // 로그아웃 버튼 이벤트 리스너를 캡처링 단계에서 등록하여 우선 실행되도록 함
    let logoutBtn = document.querySelector('.btn-logout');
    if(logoutBtn) {
      logoutBtn.removeEventListener('click', logoutBtn.onclick);
      logoutBtn.addEventListener('click', handleClickLogout, true);
    }
  })

  watch(() => jobNoticeCreate.value.schoolGb,
      (newVal) => {
        inputError.value.schoolGb = newVal === '' ? '학력을 선택하세요.' : ''
      }
  )
</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB class="snb" />
        <div class="content">
          <div class="record-wrap">
            <div class="sub-title">
              <h3>채용공고 등록</h3>
            </div>
            <p class="mt-xs">채용공고는 등록과 동시에 &lt;채용공고&gt;페이지에 공개됩니다. (<span class="red">*</span>표시는 필수 입력사항입니다.)</p>
            <p class="mt-xs">공개된 채용공고는 [마이페이지 > 상시채용관 현황]에서 관리가 가능합니다.</p>
            <!-- s: 공고 제목 -->
            <div class="content-inner resume-title">
              <KSAInput v-model="jobNoticeCreate.jobName" @input="(event) => onInputChange(event, 'jobName')" maxLength="50" placeholder="공고 제목을 50자 이내로 입력하세요." />
              <p>
                <small style="color:#E71414;">{{ inputError.jobName }}</small>
              </p>
            </div>
            <!-- e: 공고 제목 -->
            <!-- s: 모집 분야 -->
            <div class="table-form">
              <table class="vertical">
                <colgroup>
                  <col width="20%" />
                  <col />
                </colgroup>
                <tr>
                  <th colspan="2">모집 분야</th>
                </tr>
                <tr>
                  <th><span class="mark">관심 카테고리(최대3개)</span></th>
                  <td>
                    <ul class="grid category-wrap">
                      <li :class="{'active': interest.on}" v-for="interest in data_interests" @click="onClickInterest(interest)">
                        {{ interest.label }}
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.interests }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">직무</span></th>
                  <td>
                    <ul class="grid category-wrap">
                      <li :class="{'active': job.on}" v-for="job in data_job" @click="onClickJob(job)">
                        {{ job.label }}
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.job }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">모집분야명</span></th>
                  <td>
                    <KSAInput v-model="jobNoticeCreate.recruitArea" @input="(event) => onInputChange(event, 'recruitArea')" maxLength="50" placeholder="모집분야명을 입력하세요. (ex. 경영지원, 마케팅담당, 운영업무, 등)" />
                    <p>
                      <small style="color:#E71414;">{{ inputError.recruitArea }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">모집인원</span></th>
                  <td>
                    <div class="grid half">
                      <KSAInputNumber v-model="jobNoticeCreate.recruitCnt" @input="validateText('recruitCnt')" placeholder="0" maxLength="3" /> 명
                    </div>
                    <p>
                      <small style="color:#E71414;">{{ inputError.recruitCnt }}</small>
                    </p>
                  </td>
                </tr>
              </table>
            </div>
            <!-- e: 모집 분야 -->
            <!-- s: 지원 자격 / 근무조건 -->
            <div class="table-form mt-xs">
              <table class="vertical">
                <colgroup>
                  <col width="20%" />
                  <col />
                </colgroup>
                <tr>
                  <th colspan="2">지원 자격 / 근무조건</th>
                </tr>
                <tr>
                  <th><span class="mark">경력</span></th>
                  <td>
                    <ul class="grid category-wrap">
                      <li :class="{'active': jobExperience.on}" v-for="jobExperience in data_jobExperience" @click="onClickJobExperience(jobExperience)">
                        {{ jobExperience.label }}
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.jobExperience }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">학력</span></th>
                  <td>
                    <div class="grid half">
                      <KSASelect class="select" v-model="jobNoticeCreate.schoolGb" :options="$gb.SCHOOL_GB" />
                    </div>
                    <p>
                      <small style="color:#E71414;">{{ inputError.schoolGb }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">우대 사항(자격증)</span></th>
                  <td>
                    <KSAInput v-model="jobNoticeCreate.specialTreat" @input="(event) => onInputChange(event, 'specialTreat')" maxLength="50" placeholder="우대 사항은 50자이내로 입력하세요." />
                    <p>
                      <small style="color:#E71414;">{{ inputError.specialTreat }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">근무지역</span></th>
                  <td>
                    <KSASelectResidenceArea
                        class="select"
                        ref="residenceAreaRef"
                        @selectOption1="onSelectedWorkArea1"
                        @selectOption2="onSelectedWorkArea2"
                    />
                    <ul class="grid category-wrap">
                      <li :class="{'active': jobNoticeCreate.workHomeYn === 'Y'}" @click="onClickWorkHomeYn(jobNoticeCreate.workHomeYn)">
                        재택근무 가능
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.workArea }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">근무형태</span></th>
                  <td>
                    <ul class="grid category-wrap">
                      <li :class="{'active': workType.on}" v-for="workType in data_workType" @click="onClickWorkType(workType)">
                        {{ workType.label }}
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.workType }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">급여</span></th>
                  <td>
                    <div class="grid half">
                      <div class="mr-xs select-min">
                        <KSASelect class="select" v-model="jobNoticeCreate.salaryGb" :options="$gb.SALARY_GB"/>
                      </div>
                      <KSAInputNumber v-model="jobNoticeCreate.salary" :disabled="jobNoticeCreate.salaryGb === '01'" @input="validateText('salary')" maxLength="6" placeholder="0"/>
                      <span class="ml-xs">만원</span>
                    </div>
                    <p>
                      <small style="color:#E71414;">{{ inputError.salary }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>기타 요건</th>
                  <td>
                    <KSACKEditor v-model="jobNoticeCreate.note" container="public"/>
                    <!-- <span :style="{ display: 'flex', justifyContent: 'flex-end', color: (jobNoticeCreate.note && jobNoticeCreate.note.length > 4000) ? 'red' : '' }">{{jobNoticeCreate.note.length}}/4,000자</span> -->
                  </td>
                </tr>
              </table>
            </div>
            <!-- e: 지원 자격 / 근무조건 -->
            <!-- s: 채용 기간 및 방법 -->
            <div class="table-form mt-xs">
              <table class="vertical">
                <colgroup>
                  <col width="20%" />
                  <col />
                </colgroup>
                <tr>
                  <th colspan="2">채용 기간 및 방법</th>
                </tr>
                <tr>
                  <th><span class="mark">채용 기간</span></th>
                  <td>
                    <KSADatepickerTerms
                      :startDate="jobNoticeCreate.recruitStartYmd"
                      :endDate="jobNoticeCreate.recruitEndYmd"
                      @update:startDate="(value)=> jobNoticeCreate.recruitStartYmd = value"
                      @update:endDate="(value)=> jobNoticeCreate.recruitEndYmd = value"
                    />
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">면접 방식</span></th>
                  <td>
                    <template v-for="option in $gb.INTV_GB">
                      <KSARadioButton class="check-box mr-md" name="intvGb" :label="option.label" v-model="jobNoticeCreate.intvGb" :value="option.value" />
                    </template>
                    <div>
                      <small style="color:#E71414;">{{ inputError.intvGb }}</small>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">이력서 양식</span></th>
                  <td>
                    <p class="red mb-xs" v-if="jobNoticeCreate.fileYn === 'Y'">※ ‘협회 이력서’ 양식 사용을 권장합니다.</p>
                      <KSARadioButton class="check-box mr-lg" label="협회 이력서" v-model="jobNoticeCreate.fileYn" value="N" @change="resetFile('N')" />
                      <KSARadioButton class="check-box mr-lg" label="회사 이력서" v-model="jobNoticeCreate.fileYn" value="Y" @change="resetFile('Y')" />
                      <p>
                        <small style="color:#E71414;">{{ inputError.fileYn }}</small>
                      </p>
                  </td>
                </tr>
                <tr v-if="jobNoticeCreate.fileYn === 'Y'">
                  <th class="mark">회사 이력서 양식 첨부</th>
                  <td class="text-box">
                    <div class="mb-xs">
                      <p class="red">* 첨부 전 반드시 확인해주세요!</p>
                      - 의도치 않게 개인정보가 노출될 수 있으므로 첨부하는 파일에 <span class="red">실제 개인정보가 입력되어 있는지 확인</span>해주세요.<br>
                      - 첨부된 파일로 인해 개인정보가 노출될 경우 책임은 첨부한 기업에 있음을 알려드립니다.<br>
                      - 파일명은 <span class="red">‘기업명_이력서양식’</span> 으로 첨부해 주세요.
                    </div>
                    <div class="grid file" v-for="attach in jobNoticeCreate.corpResumeAttaches">
                      <KSAPrimaryButton text="파일 선택" @click="uploadFileCorpResume" />
                      <KSAInput class="input icon" v-model="createCorpFileNameSize" placeholder="파일 선택" disabled />
                      <button class="delete" @click="removeFileCorpResume"><i></i></button>
                    </div>
                    <small>최대 200MB 까지 첨부 가능</small>
                    <p>
                      <small style="color:#E71414;">{{ inputError.corpResumeAttaches }}</small>
                    </p>
                  </td>
                </tr>
              </table>
            </div>
            <!-- e: 채용 기간 및 방법 -->
          </div>
        </div>
      </div>
    </div>
    <div class="btn-wrap bottom-btn text-right">
      <div class="inner">
        <div class="flex-wrap">
          <KSASecondaryButton class="gray_button" text="취소" @click="clickCancel()" />
          <div>
            <KSAPrimaryButton text="등록 완료" @click="saveJobNotice()" :disabled="saveIsDisabled"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

@import "../../../../../assets/scss/theme";

hr {
  border: 0;
  height: 1px;
  background-color: $gray-regular_color;
  margin: 40px 0;
}

.select-min {
  .select-wrap {
    width: 30%;
  }
}

.container {
  padding-bottom: 0;
  .content {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    .record-wrap {
      width: 100%;
      margin-right: 0;
      .resume-title {
        padding: 20px 0;
      }
      .table-form {
        table {
          th {
            text-align: left;
          }
        }
      }
    }
  }
  .btn-wrap {
    .inner {
      width: calc(100% - 352px);
      margin: auto;
      padding: 0;
    }
    .flex-wrap {
      justify-content: space-between;
    }
  }
}

</style>
